import React, { useState, useRef, useEffect } from 'react'
import { Canvas, useFrame, extend } from '@react-three/fiber'
import { OrbitControls, Line, Extrude } from '@react-three/drei'
import * as THREE from 'three'

const Profiles = () => {
  const [points, setPoints] = useState([])
  const [isClosed, setIsClosed] = useState(false)
  const [extrusionDepth, setExtrusionDepth] = useState(2)
  const canvas2DRef = useRef()

  // Función para manejar clics en el área 2D
  const handleCanvasClick = (e) => {
    if (isClosed) return

    const rect = e.target.getBoundingClientRect()
    const x = ((e.clientX - rect.left) / rect.width) * 10 - 5 // Mapear a -5 a 5
    const y = -((e.clientY - rect.top) / rect.height) * 10 + 5 // Mapear a -5 a 5

    setPoints(prev => [...prev, new THREE.Vector3(x, y, 0)])
  }

  // Función para cerrar el perfil
  const closeProfile = () => {
    if (points.length < 3) return
    setPoints(prev => [...prev, prev[0].clone()])
    setIsClosed(true)
  }

  // Componente para el perfil 2D
  const Profile2D = () => (
    <div 
      ref={canvas2DRef}
      style={{
        position: 'absolute',
        width: '50%',
        height: '100%',
        top: 0,
        left: 0,
        background: '#f0f0f0',
        cursor: 'crosshair'
      }}
      onClick={handleCanvasClick}
      onDoubleClick={closeProfile}
    >
      {/* Grid y ejes */}
      <Canvas orthographic camera={{ position: [0, 0, 10], zoom: 50 }}>
        <gridHelper args={[10, 10, '#888888', '#888888']} />
        <axesHelper args={[5]} />
        
        {/* Línea del perfil */}
        {points.length > 0 && (
          <Line
            points={points.flatMap(p => [p.x, p.y, p.z])}
            color="red"
            lineWidth={2}
          />
        )}
        
        {/* Puntos */}
        {points.map((point, i) => (
          <mesh key={i} position={[point.x, point.y, 0]}>
            <sphereGeometry args={[0.1, 16, 16]} />
            <meshBasicMaterial color="blue" />
          </mesh>
        ))}
      </Canvas>
    </div>
  )

  // Componente para la extrusión 3D
  const Extrusion3D = () => {
    const shape = new THREE.Shape()
    
    if (points.length > 0) {
      shape.moveTo(points[0].x, points[0].y)
      for (let i = 1; i < points.length; i++) {
        shape.lineTo(points[i].x, points[i].y)
      }
    }

    return (
      <mesh position={[0, 0, 0]}>
        <extrudeGeometry args={[
          shape, 
          {
            steps: 1,
            depth: extrusionDepth,
            bevelEnabled: false
          }
        ]} />
        <meshPhongMaterial 
          color="#00aaff" 
          side={THREE.DoubleSide} 
          flatShading 
        />
      </mesh>
    )
  }

  return (
    <div style={{ position: 'relative', width: '100vw', height: '100vh' }}>
      <Profile2D />
      
      {/* Vista 3D */}
      <div style={{
        position: 'absolute',
        width: '50%',
        height: '100%',
        top: 0,
        right: 0,
        background: '#222222'
      }}>
        <Canvas camera={{ position: [5, 5, 5], fov: 50 }}>
          <ambientLight intensity={0.5} />
          <pointLight position={[10, 10, 10]} />
          <OrbitControls />
          
          <gridHelper args={[10, 10, '#444444', '#444444']} position={[0, -1, 0]} />
          <axesHelper args={[5]} />
          
          {isClosed && <Extrusion3D />}
        </Canvas>
      </div>

      {/* Controles UI */}
      <div style={{
        position: 'absolute',
        bottom: '20px',
        left: '20px',
        color: 'white',
        zIndex: 100,
        background: 'rgba(0,0,0,0.5)',
        padding: '10px',
        borderRadius: '5px'
      }}>
        <div>
          <label>Profundidad de extrusión: </label>
          <input 
            type="range" 
            min="0.1" 
            max="5" 
            step="0.1" 
            value={extrusionDepth}
            onChange={(e) => setExtrusionDepth(parseFloat(e.target.value))}
          />
          <span> {extrusionDepth.toFixed(1)}</span>
        </div>
        <div>
          Puntos: {points.length} | {isClosed ? 'Perfil cerrado' : 'Dibujando...'}
        </div>
        <button onClick={() => { setPoints([]); setIsClosed(false) }}>
          Reiniciar
        </button>
      </div>
    </div>
  )
}

export default Profiles